export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10304.d2fc7a38.jpg";